import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ChoiceDialogComponent } from '../ui-components/choice-dialog/choice-dialog.component';
import { EmailSettingsV2Service } from '../services/email-settings-v2.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sa-email-settings-v2',
  templateUrl: './email-settings-v2.component.html',
  styleUrls: ['./email-settings-v2.component.scss'],
})
export class EmailSettingsV2Component implements OnInit, OnDestroy {
  displayNav = false;
  displayForm = false;
  userLabel: { name: string; email: string; account: string };
  selectedEmail: any;
  emailDetails = [];
  activeDataSource: MatTableDataSource<any>;
  displayedColumns = ['loader', 'email', 'import', 'edit'];
  // @ViewChild(MatSort, { static: true }) sort: MatSort;

  isCrewLeader = false;
  subs: Subscription[] = [];

  constructor(
    public userService: UserService,
    public router: Router,
    private dialog: MatDialog,
    public emailSettingsV2Service: EmailSettingsV2Service,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.userLabel = this.userService.getLabel();
    this.isCrewLeader = this.userService.isLMOAccount() && this.userService.isCrewLeader();
    if (this.isCrewLeader) {
      this.router.navigateByUrl('/lmo');
    }
    this.activeDataSource = new MatTableDataSource([]);
    // this.activeDataSource.sort = this.sort;
    this.subs.push(
      this.emailSettingsV2Service.emailSettings$.subscribe((settings) => {
        this.activeDataSource.data = settings.data;
      }),
    );

    this.checkNewLoaderIntegration();
  }

  sortTable(event) {
    switch (event.active) {
      case 'loader':
        const sortedName = this.activeDataSource.data.sort((a, b) => {
          return a.loader.name.localeCompare(b.loader.name);
        });
        if (event.direction === 'desc') {
          sortedName.reverse();
        }
        this.activeDataSource.data = sortedName;
        break;
      case 'email':
        const sortedEmail = this.activeDataSource.data.sort((a, b) => {
          return a.email.localeCompare(b.email);
        });
        if (event.direction === 'desc') {
          sortedEmail.reverse();
        }
        this.activeDataSource.data = sortedEmail;
        break;
      case 'import':
        const sortedImportDate = this.activeDataSource.data.sort((a, b) => {
          const dateA = new Date(a.lastEmail.uploadTime);
          const dateB = new Date(b.lastEmail.uploadTime);
          return dateA.getTime() - dateB.getTime();
        });
        if (event.direction === 'desc') {
          sortedImportDate.reverse();
        }
        this.activeDataSource.data = sortedImportDate;
        break;
    }
  }

  checkNewLoaderIntegration() {
    this.emailSettingsV2Service.isNewLoaderIntegration().subscribe((value) => {
      if (value) {
        this.router.navigate(['/', 'loader-integration-v2']);
      } else {
        this.router.navigate(['/', 'loader-integration']);
      }
    });
  }

  menuClick() {
    this.displayNav = !this.displayNav;
  }

  addForm(data?) {
    this.selectedEmail = data;
    this.displayForm = true;
  }

  closeForm() {
    this.displayForm = false;
  }

  ngOnDestroy() {
    this.subs.forEach((_) => {
      _.unsubscribe();
    });
  }

  deleteEmailSettings(id) {
    const dialogRef = this.dialog.open(ChoiceDialogComponent, {
      width: '30%',
      maxWidth: '968px',
      data: {
        context: `Delete this email setting?`,
        desc: `This cannot be undone.`,
        button: ['Cancel', 'Remove Email Setting'],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const success = this.emailSettingsV2Service.deleteEmailSettings(id);
        if (success) {
          this.snackBar.open('Email deleted', null, {
            duration: 2000,
          });
        } else {
          this.snackBar.open('Failed to remove email', null, {
            duration: 2000,
            panelClass: ['snackbar-error'],
          });
        }
      }
    });
  }
}
